<template>
    <div>
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">Maximum Length</div>
            <TiptapEditor
                placeholder="Maximum length of the text"
                :show-attributes="true"
                v-model="clone.truncate.maxLength"
                :show-emoji="false"
                automation-mode
            />
            <small class="description">Enter the maximum number of characters to keep</small>
        </div>

        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">Skip Characters</div>
            <TiptapEditor
                placeholder="Number of characters to skip from the beginning"
                :show-attributes="true"
                v-model="clone.truncate.skipChars"
                :show-emoji="false"
                automation-mode
            />
            <small class="description">Optional: number of characters to skip from the start</small>
        </div>

        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">Append Ellipsis</div>
            <a-switch v-model="clone.truncate.appendEllipsis" />
            <small class="description">Add '...' at the end of truncated text</small>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";

const log = log2("StringFormatterTruncate");
export default {
    name: "StringFormatterTruncate",
    components: { TiptapEditor },
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            mode: "string.truncate",
            value: "",
            truncate: {
                maxLength: "0",
                skipChars: "0",
                appendEllipsis: false,
            }
        };
        return {
            clone,
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
        value(newValue) {
            if (_.isEqual(newValue, this.clone)) return;
            this.clone = _.cloneDeep(newValue);
        },
    },
};
</script>

<style lang="scss" scoped>
.editor-row {
    width: 100%;

    &.customize-editor-minimize {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    small.description {
        font-size: 10px;
        color: var(--color-text-weak-default);
    }

    .editor-row-title {
        font-weight: bold;
        font-size: 16px;
    }
}
</style> 